(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[1312],{

/***/ 59549:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/sign-in",
      function () {
        return __webpack_require__(50638);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 50638:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(93712);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(18316);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(11527);
/* harmony import */ var _metatrustlabs_ui_base__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(90333);
/* harmony import */ var components_layout_PublicPage__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(38739);
/* harmony import */ var hooks_useKeycloak__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(5854);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(88518);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(next_head__WEBPACK_IMPORTED_MODULE_4__);







var SignUp = function() {
    var ref = (0,hooks_useKeycloak__WEBPACK_IMPORTED_MODULE_3__/* .useKeycloak */ .Eh)(), login = ref.actions.login;
    login({
        redirectUri: "https://app.metatrust.io"
    });
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_metatrustlabs_ui_base__WEBPACK_IMPORTED_MODULE_1__/* .LoadingCircular */ .CE, {
        className: "mx-auto mt-24 h-12 w-12 text-orange-500"
    });
};
SignUp.layout = function(props) {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(components_layout_PublicPage__WEBPACK_IMPORTED_MODULE_2__["default"], (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({
        showBgImage: true,
        showHeader: false
    }, props), {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)((next_head__WEBPACK_IMPORTED_MODULE_4___default()), {
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        property: "og:title",
                        content: "MetaScan - Sign In"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        property: "og:type",
                        content: "type tag (website)"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        property: "og:description",
                        content: "MetaScan uses a revolutionary approach designed to be developer-first. It combines multiple state-of-art security scanning engines into one single platform with unprecedented speed and accuracy, securing every aspect of your application beyond the smart contract layer."
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        property: "og:url",
                        content: "https://app.metatrust.io/sign-in"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        property: "og:image",
                        content: "https://storage.googleapis.com/metatrust/metascan/og-cover.png"
                    })
                ]
            }),
            props.children
        ]
    }));
};
/* harmony default export */ __webpack_exports__["default"] = (SignUp);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [7395,333,5671,1327,6301,5423,4703,8111,8677,7254,700,5336,1228,7283,292,6540,8739,9774,2888,179], function() { return __webpack_exec__(59549); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);